import React from "react";
import { useAuth } from "../auth/AuthContext";
import { siteCopy } from "../i18n/siteCopy";
import { useManualLocale } from "../manual/i18n/LocaleContext";

export default function AccountMenu() {
  const { user, signOut } = useAuth();
  const { locale } = useManualLocale();
  const copy = siteCopy[locale];
  if (!user) return null;
  const name = `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.email;

  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="hidden text-sm text-gray-600 dark:text-gray-300 truncate max-w-[12rem] sm:inline" title={user.email}>
        {name}
      </span>
      <button
        type="button"
        onClick={signOut}
        className="text-sm font-medium text-sepm-primary dark:text-sepm-primary-dark hover:underline whitespace-nowrap"
      >
        {copy.signOut}
      </button>
    </div>
  );
}
